import { ProductTypeEnum } from '../../model/enums/ProductTypeEnum';

const NavigationSteps = {
  [ProductTypeEnum.ORV]: [
    {
      label: 'Navigation.Calculate',
      order: 1,
      active: false,
      finished: false,
    }, {
      label: 'Navigation.PersonalData',
      order: 2,
      active: false,
      finished: false,
    }, {
      label: 'Navigation.InsuranceData',
      order: 3,
      active: false,
      finished: false,
    }, {
      label: 'Navigation.Complete',
      order: 4,
      active: false,
      finished: false,
    }
  ],
  [ProductTypeEnum.GG]: [
    {
      label: 'Navigation.Calculate',
      order: 1,
      active: false,
      finished: false,
    }, {
      label: 'Navigation.ProductData',
      order: 2,
      active: false,
      finished: false,
    }, {
      label: 'Navigation.KnowledgeTest',
      order: 3,
      active: false,
      finished: false,
    }, {
      label: 'Navigation.PersonalData',
      order: 4,
      active: false,
      finished: false,
    }, {
      label: 'Navigation.Complete',
      order: 5,
      active: false,
      finished: false,
    }
  ],
};

export default NavigationSteps;
